@if(breakpointService.isDesktop()) {
  <app-things-to-do-desktop></app-things-to-do-desktop>
} @else {
 <app-things-to-do-mobile></app-things-to-do-mobile>
}
